import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";

export const ReportS3 = () => {
    const {year, bullstat} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    useEffect(() => {
        request.get(`${baseUrl()}/reports/s3/${year}/${bullstat}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/s3/${year}/${bullstat}?format=pdf`, `S3_${bullstat}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c = data.company;
    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С10 — ДЗ кръстосана по ползвател</h5>
                    <div>{c.company_name}, Булстат: {c.bullstat}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            {data.receives.length > 0 && (
                <>
                    <h6 className="fw-bold mt-3">ПОЛУЧАВА ОТ:</h6>
                    <table className="table table-sm table-bordered">
                        <thead className="tableHead">
                        <tr>
                            <th>Ползвател</th>
                            <th>За село</th>
                            <th>От село</th>
                            <th className="text-end">Сума (дка)</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.receives.map((r, i) => (
                            <tr key={i}>
                                <td>{r.company_other}</td>
                                <td>{r.settlement}</td>
                                <td>{r.settlement_other}</td>
                                <td className="text-end">{r.amount.toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr className="fw-bold">
                            <td colSpan={3}>ОБЩО получава</td>
                            <td className="text-end">{data.total_receives.toFixed(2)}</td>
                        </tr>
                        </tfoot>
                    </table>
                </>
            )}

            {data.gives.length > 0 && (
                <>
                    <h6 className="fw-bold mt-3">ДАВА НА:</h6>
                    <table className="table table-sm table-bordered">
                        <thead className="tableHead">
                        <tr>
                            <th>Ползвател</th>
                            <th>За село</th>
                            <th>От село</th>
                            <th className="text-end">Сума (дка)</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.gives.map((g, i) => (
                            <tr key={i}>
                                <td>{g.company_other}</td>
                                <td>{g.settlement}</td>
                                <td>{g.settlement_other}</td>
                                <td className="text-end">{g.amount.toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr className="fw-bold">
                            <td colSpan={3}>ОБЩО дава</td>
                            <td className="text-end">{data.total_gives.toFixed(2)}</td>
                        </tr>
                        </tfoot>
                    </table>
                </>
            )}

            <div className="fw-bold mt-3" style={{fontSize: "1.1em"}}>
                Разлика (получава - дава): {(data.total_receives - data.total_gives).toFixed(2)}
            </div>
        </div>
    );
};
